import {useEffect, useState} from "react";
import api from "../api/api";
import {IMAGE_URL} from "../path";
import '../styles/LetsCook.css';
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import byProduct from '../assets/icons/by product (1).svg';
import byCuisine from '../assets/icons/by cuisine (1).svg';
import {Link} from "react-router-dom";
import cartonBackground from "../assets/images/carton-background.jpg";
import SEO from "./Components/SEO";

type LetsCookProps = {
    cover_image: string;
}

type LetsCookResponse = {
    message: string;
    header_image: LetsCookProps;
}
function LetsCook() {
    const [letsCook, setLetsCook] = useState<LetsCookProps | null>(null)
    const [loading, setLoading] = useState<boolean>(false);

    const fetchLetsCook = async () => {
        try {
            const response = await api.get<LetsCookResponse>("/fetch-lets-cook");

            setLetsCook(response.data.header_image);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLetsCook();
    }, []);

    return (
        <div>
            <SEO
                title="Let's Cook | DENNY"
                description="Looking for mealtime inspiration? Discover easy, fail-proof recipes by your favourite Denny product or explore by cuisine, and cook with confidence"
                keywords="Let's Cook, DENNY recipes, recipes, cooking inspiration, browse recipes, recipe finder, meal ideas, easy recipes, home cooking, DENNY South Africa"
            />
            <div className="lets-cook-header">
                <Header />
                <div className="lets-cook-header-inner">
                    <h1>Let’s Cook</h1>
                    <p>Looking for mealtime inspiration? Discover easy, fail-proof recipes by your favourite Denny product or explore by cuisine, and cook with confidence</p>
                </div>
            </div>
            <div className="lets-cook-body">
                <div className={"lets-cook-box"}>
                    <div className="lets-cook-box-icon">
                        <img src={byProduct} />
                    </div>
                    <h2>Browse by Product</h2>
                    <p>Already have a favourite product? Select it and discover three curated recipes crafted just for it.</p>
                    <Link to={"/lets-cook/by-product"} className="lets-cook-link">Start Cooking</Link>
                </div>
                <div className={"lets-cook-box"}>
                    <div className="lets-cook-box-icon">
                        <img src={byCuisine} />
                    </div>
                    <h2>Browse by Cuisine</h2>
                    <p>Tell us your preference - cuisine, skill level, protein, and dietary needs - and we’ll find the perfect match.</p>
                    <Link to={"/lets-cook/by-cuisine"} className="lets-cook-link">Start Cooking</Link>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default LetsCook;
